import { apiAccount } from 'api'
import types from './types'
import { setColumnsView } from 'redux/actions/cv_search'


const get = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiAccount
      .settings.get(data)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch({ type: types.SETTINGS_OPERATOR, settings: data || {} })

          if (data?.conversation?.searchUserCols?.length) {
            dispatch(setColumnsView(data?.conversation?.searchUserCols))
          }

          return resolve(data)
        }
        return reject(data)
      })
      .catch(() => {
        dispatch({ type: types.SETTINGS_OPERATOR, settings: data || {} })
      })
  })
}

const set = (data) => (dispatch, getState) => {
  const { settings } = getState()
  const prevSettings = { ...settings }
  const updatedSettings = { ...settings, ...data }

  dispatch({ type: types.SETTINGS_OPERATOR, settings: updatedSettings })

  apiAccount.settings.set(data)
    .catch(() => dispatch({ type: types.SETTINGS_OPERATOR, settings: prevSettings }))
}

const remove = (id) => (dispatch, getState) => {
  const settings = getState().settings
  settings.smartChatCollapse.forEach((it, idx) => {
    if (it.processId === id)
      settings.smartChatCollapse.splice(idx, 1)
  })
  dispatch(set({ smartChatCollapse: settings.smartChatCollapse }))
}

export default {
  get,
  set,
  remove,
}
